import styled from 'styled-components';

export const HeroContainer = styled.div`
 margin-top: 60px;
 
 @media(min-width: 768px){
     margin-top: 75px;
 }
 
 @media (min-width: 992px) {
    margin-top: 85px;
  }
 
 @media(min-width: 1200px){
     margin-top: 95px;
 }
`;

export const SectionContainer = styled.div`
  padding: 26px 20px 0;
`;

// container for body after first sections in every page
export const BodyContainer = styled.div`
  padding: 32px 16px 50px;
  position: relative;

  @media(min-width: 768px){
    padding: 40px 100px;
  }
  
  @media(min-width: 992px) {
    padding: 50px 120px;
  }
  
  @media(min-width: 1200px) {
    padding: 50px 180px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/Container/Container.js